// API Configuration
export const API_URL = 'https://circle-lgd7.vercel.app/api';
export const extension_id = "4";

// Admin API Configuration - using localhost for development
export const ADMIN_API_URL = 'https://circle-lgd7.vercel.app/api';

// Admin authentication helper using proper OAuth endpoint
export const authenticateAdmin = async (authKey, uid) => {
  try {
    console.log('Authenticating admin with authKey:', authKey, 'uid:', uid);
    
    const response = await fetch(`${ADMIN_API_URL}/oauth`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uid,
        authKey
      }),
    });

    if (response.ok) {
      const data = await response.json();
      console.log('OAuth response:', data);
      
      return {
        success: true,
        adminData: data.data
      };
    } else {
      const errorData = await response.json();
      console.error('OAuth authentication failed:', response.status, errorData);
      return {
        success: false,
        error: errorData.error || 'Authentication failed'
      };
    }
  } catch (error) {
    console.error('Admin authentication error:', error);
    return {
      success: false,
      error: 'Network error during authentication'
    };
  }
};

// Validate existing admin session using proper OAuth endpoint
export const validateAdminSession = async () => {
  try {
    const response = await fetch(`${ADMIN_API_URL}/oauth`, {
      method: 'GET',
      credentials: 'include', // Include cookies for session validation
    });

    if (response.ok) {
      const data = await response.json();
      console.log('Session validation response:', data);
      
      return {
        isValid: true,
        adminData: data.data
      };
    } else {
      const errorData = await response.json();
      console.log('Session validation failed:', response.status, errorData);
      return {
        isValid: false,
        error: errorData.error || 'Session validation failed'
      };
    }
  } catch (error) {
    console.error('Session validation error:', error);
    return {
      isValid: false,
      error: 'Network error during session validation'
    };
  }
}; 